import styled from 'styled-components';

export const WrapperIndicator = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  .text-title {
    margin: 20px 20px 0px 20px;
  }

  .section-info {
    display: flex;
    flex-direction: row;
  }
  .section-indicator-0 {
    display: grid;
    grid-template-columns: 30% 70%; 
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    width: 85%;
    margin: 15px;
    border-radius: 5px;
    padding: 10px;
    color: white;
    background-color: #0f83c9;
    .section-icon {
      grid-area: 1 / 1 / 3 / 2;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .section-text {
      grid-area: 1 / 2 / 3 / 3;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  .section-indicator-1 {
    display: grid;
    grid-template-columns: 30% 70%;
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    width: 85%;
    margin: 15px;
    border-radius: 5px;
    padding: 10px;
    color: white;
    background-color: #ffa640;
    .section-icon {
      grid-area: 1 / 1 / 3 / 2;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .section-text {
      font-size: 14px;
      grid-area: 1 / 2 / 3 / 3;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  .section-indicator-2 {
    display: grid;
    grid-template-columns: 30% 70%;
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    width: 85%;
    margin: 15px;
    border-radius: 5px;
    padding: 10px;
    color: white;
    background-color: #999693;
    .section-icon {
      grid-area: 1 / 1 / 3 / 2;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .section-text {
      grid-area: 1 / 2 / 3 / 3;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
`;

export const ButtonIndicator = styled.button`
  display: flex;
  width: 50%;
`;
